/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { locationReload } from "@eroad/helpers/locationReload";

import { eroadTheme } from "../../../theme/eroadTheme";
import { UnauthenticatedHeader } from "../unauthenticatedHeader/UnauthenticatedHeader";

type SafeErrorPageProps = {
  showHeader?: boolean;
};

/**
 * This component must be implemented without using AntD or any
 * external libraries other than React. Unfortunately, it cannot
 * be internationalised either.
 */
const PageSafeError = ({ showHeader }: SafeErrorPageProps): JSX.Element => (
  <div style={{ height: "100vh" }}>
    {showHeader && <UnauthenticatedHeader />}
    <main
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: showHeader ? "calc(100vh - 64px)" : "100vh",
        backgroundColor: "white",
      }}
    >
      <h1>Road closed!</h1>
      <p>Our dedicated team are looking into it. Try again later.</p>
      <a
        onClick={locationReload}
        style={{
          fontWeight: 500,
          fontSize: 16,
          lineHeight: 2.4,
          color: eroadTheme.colors.primaryBlueDefault,
        }}
      >
        RELOAD PAGE
      </a>
    </main>
  </div>
);

export { PageSafeError };
